import ItemStatus from '@/Enums/ItemStatus.enum';
import ScreenKey from '@/Enums/Screens/ScreenKey.enum';
import { ICreative } from '@/Interfaces/Creatives/Creative.interface';
import IOSSwitch from '@/components/Switch';
import { CREATIVE_STATUSES_TITLES } from '@/constants/creativeLibrary';
import { useAppSelector } from '@/store/hooks';
import { selectMeScreenAccess } from '@/store/selectors/me.selectors';
import { CreativeStatus } from '@/types/creativeLibrary';
import { useState } from 'react';

interface IProps {
  row: ICreative;
  handleChangeStatus: (id: number, status: CreativeStatus) => Promise<void>;
}

const StatusCell = ({ row, handleChangeStatus }: IProps) => {
  const [loading, setLoading] = useState(false);

  const readOnly = useAppSelector(selectMeScreenAccess(ScreenKey.CREATIVE_LIBRARY));

  const _handleChangeStatus = async () => {
    setLoading(true);
    await handleChangeStatus(row.id, row.status === ItemStatus.ACTIVE ? ItemStatus.INACTIVE : ItemStatus.ACTIVE);
    setLoading(false);
  };

  return (
    <div className='flex justify-center items-center gap-2'>
      <p className='font-semibold'>{CREATIVE_STATUSES_TITLES[row.status!]}</p>
      <IOSSwitch
        checked={row.status === ItemStatus.ACTIVE}
        onChange={_handleChangeStatus}
        disabled={loading || readOnly}
      />
    </div>
  );
};

export default StatusCell;
